import { graphql } from 'gatsby'
import tw from 'twin.macro'
import Link from '@/components/link-component'
import Image from './image'

export const fragment = graphql`
  fragment Cta on ContentfulComponentCta {
    __typename
    contentful_id
    title
    buttonText
    link: url {
      ...Link
    }
    image {
      ...Asset
    }
    backgroundColor
  }
`

export default function Cta({
  title,
  buttonText,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore this line doesn't recognize alias rename
  link,
  image,
  backgroundColor,
}: Queries.ContentfulComponentCta): JSX.Element {
  return (
    <div
      tw="bg-indigoBlue rounded-3xl flex items-center flex-col-reverse sm:(flex-row) break-inside-avoid-page"
      css={[
        backgroundColor === 'Primary' && tw`bg-primaryBlue`,
        backgroundColor === 'Secondary' && tw`bg-indigoBlue`,
        backgroundColor === 'Tertiary' && tw`bg-indigoBlue`,
      ]}
    >
      <div tw="p-8" css={[!!image && tw`sm:(w-1/2)`]}>
        <h2 tw="text-xl text-white mb-6 font-normal leading-tight text-center sm:(text-left)">{title}</h2>
        <div tw="flex justify-center w-full sm:(block)">
          <Link to={link?.url} tw="inline-block text-center">
            <div
              tw="bg-white px-8 py-2 rounded-full font-bold text-center hover:(bg-gray-100)"
              css={[
                backgroundColor === 'Primary' && tw`text-primaryBlue`,
                backgroundColor === 'Secondary' && tw`text-indigoBlue`,
                backgroundColor === 'Tertiary' && tw`text-indigoBlue`,
              ]}
            >
              {buttonText}
            </div>
          </Link>
        </div>
      </div>
      {image && (
        <div tw="sm:(w-1/2) flex items-center justify-center p-8 pb-0 sm:(pb-8)">
          <Image image={image} />
        </div>
      )}
    </div>
  )
}
